<template>
    <div>
        <div class="md:flex md:items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <router-link
                    :to="{ name: 'editVenue' }"
                    class="mb-2 flex items-center text-sm text-gray-500"
                >
                    <base-back-icon />
                    <span>Settings</span>
                </router-link>
                <base-page-title title="Uber Direct Settings" />
            </div>

            <BaseSpinner :isLoading="isLoading" />
        </div>

        <div class="mt-4 md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <div class="sm:pl-0 sm:pr-5">
                    <h3 class="text-base font-semibold leading-6 text-gray-800">
                        Details
                    </h3>
                    <p class="mt-2 text-sm text-gray-500">
                        Connect to Uber Direct.
                        <br /><br />If you don't have a Uber Direct account yet,
                        you can learn how to
                        <a
                            class="text-indigo-600"
                            href="https://direct.uber.com/"
                            target="_blank"
                        >
                            create one here
                        </a>
                    </p>
                </div>
            </div>
            <div
                v-if="!isLoading"
                class="mt-5 w-full bg-white p-2 text-left shadow sm:rounded-md sm:p-4 md:col-span-2 md:mt-0"
            >
                <div v-if="!isUberDirectConnected">
                    <base-input-field
                        id="client-id"
                        label="Client ID"
                        v-model="clientId"
                        class="mb-4"
                        :errors="$v.clientId.$error"
                    />

                    <base-input-field
                        id="secret"
                        label="Secret"
                        v-model="secret"
                        class="mb-4"
                        :errors="$v.secret.$error"
                    />

                    <base-input-field
                        id="signing-key"
                        label="Signing Key"
                        v-model="signingKey"
                        class="mb-4"
                        :errors="$v.signingKey.$error"
                    />

                    <base-button
                        type="button"
                        class="flex justify-end"
                        button-text="Connect to Uber Direct"
                        @clicked="connectToUberDirect"
                    />
                </div>
                <div v-else>
                    <base-input-field
                        id="customer-id"
                        label="Customer ID"
                        v-model="settings.customerId"
                        class="mb-4"
                    />

                    <toggle-switch
                        label="Enable Uber Direct"
                        v-model="settings.enabled"
                    />

                    <base-button
                        type="button"
                        class="flex justify-end"
                        button-text="Save"
                        @clicked="saveVenue"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

import ToggleSwitch from '@/components/formComponents/ToggleSwitch.vue';

export default {
    name: 'UberDirectSettings',
    metaInfo: {
        title: 'Uber Direct Integration'
    },
    components: { ToggleSwitch },
    props: {
        venueId: {
            type: Number,
            required: true
        },
        venue: {
            type: Object,
            required: true
        }
    },
    data() {
        const defaultSettings = {
            customerId: this.venue.integrations?.uberDirect?.customerId || '',
            enabled: this.venue.integrations?.uberDirect?.enabled || false
        };
        return {
            isLoading: false,
            clientId: null,
            secret: null,
            signingKey: null,
            isUberDirectConnected: false,
            settings: { ...defaultSettings }
        };
    },
    validations: {
        clientId: { required },
        secret: { required },
        signingKey: { required }
    },
    async mounted() {
        this.isLoading = true;

        await this.checkIsUberDirectConnected();

        this.isLoading = false;
    },
    methods: {
        async connectToUberDirect() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.isLoading = true;

            try {
                const payload = {
                    clientId: this.clientId,
                    secret: this.secret,
                    signingKey: this.signingKey
                };

                await this.$axios.post('/uber-direct/auth', payload);
            } catch (error) {
                throw new Error(`API ${error}`);
            } finally {
                await this.checkIsUberDirectConnected();
                this.isLoading = false;
            }
        },
        async checkIsUberDirectConnected() {
            try {
                const { data } = await this.$axios.get('/account/check', {
                    params: {
                        columnName: 'uberDirect'
                    }
                });

                this.isUberDirectConnected = !data ? false : true;
            } catch (error) {
                throw new Error(`API ${error}`);
            }
        },
        async saveVenue() {
            try {
                const payload = {
                    id: this.venueId,
                    integrations: {
                        ...this.venue.integrations,
                        uberDirect: this.settings
                    }
                };

                await this.$store.dispatch('venues/update', payload);

                this.$notify({
                    group: 'settings',
                    title: 'Settings saved'
                });
            } catch (error) {
                throw new Error(`API ${error}`);
            }
        }
    }
};
</script>
